import { render } from "./dateFormatter.vue?vue&type=template&id=042f45d0"
import script from "./dateFormatter.vue?vue&type=script&lang=js"
export * from "./dateFormatter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__